// libs
import { useSelector } from 'react-redux';

// defs
import { RemoteConfigState } from './types';

export const useRemoteConfig = <T extends keyof RemoteConfigState>(
  config: T,
  defaultValue?: RemoteConfigState[T]
): RemoteConfigState[T] =>
  useSelector((state: { remoteConfigs: RemoteConfigState }) => {
    const value = state.remoteConfigs?.[config];
    if (value !== undefined) {
      return value;
    }

    // Fallback to defaultValue param
    // Note: SSR always hydrates with full config from server/middleware/remoteConfig.ts
    return defaultValue as RemoteConfigState[T];
  });
